export const isProfileOnline = (profile) => {
  if (!profile || profile.online !== true) return false;
  if (!profile.lastActive) return false;
  
  try {
    const lastActiveTime = new Date(profile.lastActive).getTime();
    const now = new Date().getTime();
    const minutesSinceActive = (now - lastActiveTime) / (1000 * 60);
    
    // Consider offline if lastActive is older than 10 minutes
    // (App pings every 5 minutes when the tab is visible)
    return minutesSinceActive < 10;
  } catch (e) {
    return false;
  }
};
